// extracted by mini-css-extract-plugin
export default {"container":"BusyIndicator_container__3WSHm","fullScreen":"BusyIndicator_fullScreen__sFnRn","text":"BusyIndicator_text__LCu-I"};